import { useEffect, useState } from 'react';

function useIsMobile(size?: number) {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : (size ?? 1200),
  );

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    handleWindowSizeChange();

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  const isMobile = width <= (size ?? 1200); //  xl bootstrap breakpoint
  return isMobile;
}

export default useIsMobile;
